export default __webpack_public_path__ + "static/about-heart@2x-with-branches-4288ae0e57c211be0e9bdcceedf4849e.png";